<div class="hero-results" *ngIf="content">
  <div class="left-column">
    <app-picture
      [source]="content.fields.backgroundImage.fields.file.url"
      [isBackground]="true"
      [type]="'sidebar'"
      [alt]="''"
    >
    </app-picture>
    <div class="co2-wrapper">
      <h1 class="title">{{ content.fields.co2eTitle }}</h1>
      <div class="co2" *ngIf="testResult">
        <strong class="co2__number">{{ testResult.co2e | round: -1 }}</strong> <span class="co2__label">kg CO₂e</span>
      </div>
      <div class="co2-explanation">
        <img
          class="co2-explanation__icon"
          [src]="content.fields.co2eIcon.fields.file.url"
          [alt]="content.fields.co2eIcon.fields.description || ''"
          loading="lazy"
        />
        <div class="co2-explanation__text">
          {{ content.fields.co2eLowerText }}
        </div>
      </div>
    </div>
  </div>

  <div class="right-column">
    <h2 class="right-column__title">{{ content.fields.statsBarHeading }}</h2>
    <div class="stats" *ngIf="testResult">
      <app-test-result-category-chart [testResult]="testResult"></app-test-result-category-chart>
    </div>

    <div class="infographics">
      <div class="infographics-item">
        <img
          [src]="content.fields.oilInfographicsIcon.fields.file.url"
          [alt]="content.fields.oilInfographicsIcon.fields.description || ''"
          loading="lazy"
        />
        <h2 class="infographics-item__heading">{{ oilHeading }}</h2>

        <div class="infogpraphics-item__explanation">{{ content.fields.oilInfographicsExplanation }}</div>
      </div>

      <div class="sharing" *ngIf="linkToShare$ | async as linkToShare">
        <h4 class="sharing__title">{{ content.fields.shareResultTitle }}</h4>
        <app-share-link
          [linkToShare]="linkToShare"
          [title]="title"
          [mailBody]="content?.fields.shareToMailBody.content"
          [analyticsCategory]="'Click on share result'"
        >
        </app-share-link>
      </div>

      <!--<div class="infographics-item">
        <img
          [src]="content.fields.treesInfographicsIcon.fields.file.url"
          [alt]="content.fields.treesInfographicsIcon.fields.description"
          loading="lazy"
        />
        <h2 class="infographics-item__heading">{{ treesHeading }}</h2>
      </div>-->
    </div>
  </div>
</div>
